import MediaQuery from './MediaQuery'

export default class NavigationMobile {
    static META_NAV_CLASS = 'js__meta-nav'
    static META_NAV_OPEN_SEARCH_ON_CLICK_CLASS = 'js__meta-nav-open-search-on-click'
    static MAIN_NAV_CLASS = 'js__main-nav-mobile'
    static MAIN_NAV_MENU_VISIBLE_CLASS = 'js__main-nav-visible'
    static MAIN_NAV_VISIBLE_MOBILE_CLASS = 'nav-is-visible'
    static MAIN_NAV_OPEN_SUBMENU_CLASS = 'js__main-nav-open-sub'
    static MAIN_NAV_CLOSE_SUBMENU_CLASS = 'js__main-nav-close-sub'
    static MAIN_NAV_OPEN_MENU_CLASS = 'js__main-nav-toggle'
    static MAIN_NAV_BACKGROUND_OVERLAY = 'js__main-nav-overlay'
    static MAIN_NAV_OPEN_INTERNAL_LINK_CLASS = 'js__main-nav__internal-link'
    static MAIN_NAV_VISIBLE_CLASS = 'visible'
    static MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS = 'main-nav__link--sub-open'
    static MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS = 'main-nav-background-visible'
    static MAIN_NAV_LINK_CLASS = 'main-nav__link'
    static HEADER_READING_MODE_CLASS = 'header__reading-mode'
    searchScriptIsLoaded = false

    constructor() {
        if (!document.getElementsByClassName(NavigationMobile.HEADER_READING_MODE_CLASS).length > 0) {
            this.mainNav = document.getElementsByClassName(NavigationMobile.MAIN_NAV_CLASS)[0]
            this.metaNav = document.getElementsByClassName(NavigationMobile.META_NAV_CLASS)[0]
            this.bindEvents()
        }
    }

    bindEvents() {
        this.bindBurgerButton()
        this.bindOpenSubTriggerElements()
        this.bindCloseSubTriggerElements()
        this.bindBackgroundOverlay()
    }

    /**
     * Mobile layout burger button logic
     */
    bindBurgerButton() {
        const burgerButton = document.getElementsByClassName(NavigationMobile.MAIN_NAV_OPEN_MENU_CLASS)[0]
        burgerButton.addEventListener('click', () => {
            this.closeAllSubMenus()
            document.body.classList.toggle(NavigationMobile.MAIN_NAV_MENU_VISIBLE_CLASS)
            document.body.classList.remove(NavigationMobile.MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS)
            document.body.classList.toggle(NavigationMobile.MAIN_NAV_VISIBLE_MOBILE_CLASS)
        })
    }

    /**
     * Mobile layout back button logic
     */
    bindCloseSubTriggerElements() {
        const closeSubTriggerElements = this.mainNav.getElementsByClassName(
            NavigationMobile.MAIN_NAV_CLOSE_SUBMENU_CLASS
        )
        for (const closeSubTriggerElement of closeSubTriggerElements) {
            closeSubTriggerElement.addEventListener('click', function () {
                this.classList.remove(NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS)
                this.parentNode.classList.remove(NavigationMobile.MAIN_NAV_VISIBLE_CLASS)
            })
        }
    }

    /**
     * Mobile and desktop layout logic for opening second navigation level
     */
    bindOpenSubTriggerElements() {
        const mainNavInternalLinks = this.mainNav.getElementsByClassName(
            NavigationMobile.MAIN_NAV_OPEN_INTERNAL_LINK_CLASS
        )

        //Special case for internal anchor links in the main navigation
        for (const mainNavInternalLink of mainNavInternalLinks) {
            mainNavInternalLink.addEventListener('click', (e) => {
                let url = e.target.href
                //Check if the link url contains an anchor hash and if the link has the same path as the current url
                if (url.indexOf('#') !== -1 && window.location.pathname === e.target.pathname) {
                    e.preventDefault()
                    //Set the url from the link as current
                    window.location.assign(url)
                    //Make a real reload, since we want to have a real page reload when a there is an anchor link in the main navigation
                    window.location.reload()
                }
            })
        }
        const openSubTriggerElements = this.mainNav.getElementsByClassName(NavigationMobile.MAIN_NAV_OPEN_SUBMENU_CLASS)

        for (const openSubTriggerElement of openSubTriggerElements) {
            // Desktop layout mouse handling
            openSubTriggerElement.addEventListener('mouseover', (e) => {
                if (MediaQuery.UpMd.matches) {
                    setTimeout(() => {
                        let relatedTarget = e.target
                        if (relatedTarget.matches(':hover')) {
                            this.closeAllSubMenus()
                            this.openSub(e)
                        }
                    }, 300)
                }
            })

            // Mobile layout mouse handling
            openSubTriggerElement.addEventListener('click', (e) => {
                // Only open sub nav if on mobile layout and no link is clicked
                if (!MediaQuery.UpMd.matches) {
                    e.preventDefault()
                    this.closeAllSubMenus()
                    this.openSub(e)
                }
            })

            // Mobile & Desktop layout touch handling
            openSubTriggerElement.addEventListener('touchend', (e) => {
                // If on desktop layout and the link is touched once preventDefault and open nav, on the second touch open the link
                if (
                    MediaQuery.UpMd.matches &&
                    !e.target.classList.contains(NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS)
                ) {
                    e.preventDefault()
                }

                // Only open sub nav when on desktop layout or no link is touched
                if (MediaQuery.UpMd.matches || !e.target.classList.contains(NavigationMobile.MAIN_NAV_LINK_CLASS)) {
                    this.closeAllSubMenus()
                    // I know timeouts are not cool, but the 100ms don't really affect the perceived performance. This is needed for iOS devices >iOS 13
                    setTimeout(() => this.openSub(e), 100)
                }
            })
        }
    }

    openSearch(e) {
        document.body.classList.add(Navigation.MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS)
        document.body.classList.add(Navigation.MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS)
        document.body.classList.add('meta-nav__search-open')
        e.target.classList.add(Navigation.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS)
        const submenu = e.target.closest('.main-nav__list-item').querySelector('.main-nav__search-wrapper')
        submenu.classList.add(Navigation.MAIN_NAV_VISIBLE_CLASS)
    }

    loadSearchScript() {
        if (!this.searchScriptIsLoaded) {
            this.searchScriptIsLoaded = true
            let searchScript = document.querySelector('.js-site-search')
            searchScript.setAttribute('type', 'text/javascript')
            searchScript.parentElement.appendChild(searchScript)
            document.addEventListener('suggestIsLoaded', () => {
                const suggestInput = document.querySelector('.suggest__input')
                suggestInput.focus()
            })
        }
    }

    /**
     * Desktop layout background overlay logic for closing second level nav
     */
    bindBackgroundOverlay() {
        // note: disable this to prohibit submenus from closing
        document
            .getElementsByClassName(NavigationMobile.MAIN_NAV_BACKGROUND_OVERLAY)[0]
            .addEventListener('mouseover', () => {
                this.closeAll()
            })
    }

    openSub(e) {
        document.body.classList.add(NavigationMobile.MAIN_NAV_MENU_VISIBLE_CLASS)
        document.body.classList.add(NavigationMobile.MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS)
        e.target.classList.add(NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS)
        const submenu = e.target.closest('.main-nav__list-item').querySelector('.main-nav__sub-wrapper')
        submenu.classList.add(NavigationMobile.MAIN_NAV_VISIBLE_CLASS)
    }

    openSearch(e) {
        document.body.classList.add(NavigationMobile.MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS)
        e.target.classList.add(NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS)
        const submenu = e.target.closest('.main-nav__list-item').querySelector('.main-nav__search-wrapper')
        submenu.classList.add(NavigationMobile.MAIN_NAV_VISIBLE_CLASS)
    }

    closeAll() {
        this.closeAllSubMenus()
        document.body.classList.remove(NavigationMobile.MAIN_NAV_MENU_VISIBLE_CLASS)
        document.body.classList.remove(NavigationMobile.MAIN_NAV_VISIBLE_MOBILE_CLASS)
        document.body.classList.remove(NavigationMobile.MAIN_NAV_BACKGROUND_OVERLAY_VISIBLE_CLASS)
    }

    closeAllSubMenus() {
        document.body.classList.remove('meta-nav__search-open')

        const visibleMainNavSubs = this.mainNav.getElementsByClassName(NavigationMobile.MAIN_NAV_VISIBLE_CLASS)
        const visibleMetaNavSubs = this.metaNav.getElementsByClassName(NavigationMobile.MAIN_NAV_VISIBLE_CLASS)
        const visibleSubs = [].concat(Array.from(visibleMainNavSubs)).concat(Array.from(visibleMetaNavSubs))
        for (const visibleSub of visibleSubs) {
            visibleSub.classList.remove(NavigationMobile.MAIN_NAV_VISIBLE_CLASS)
        }

        const mainNavLinkSubVisibles = this.mainNav.getElementsByClassName(
            NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS
        )
        const metaNavLinkSubVisibles = this.metaNav.getElementsByClassName(
            NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS
        )
        const linkSubVisibles = [].concat(Array.from(mainNavLinkSubVisibles)).concat(Array.from(metaNavLinkSubVisibles))
        for (const linkSubVisible of linkSubVisibles) {
            linkSubVisible.classList.remove(NavigationMobile.MAIN_NAV_LINK_SUBMENU_VISIBLE_CLASS)
        }
    }
}
